var escapeRegExp, initRegExp, normalizeQuery, regexp, replacements;

escapeRegExp = require('../../../../../core/frontend/common/underscore_mixins').escapeRegExp;

regexp = replacements = null;

initRegExp = function() {
  var char, charMap, dest, i, key, len, len1, src, val;
  charMap = window.Groupon.LS.data.charMapping || {};
  replacements = {};
  regexp = '';
  val = _.values(charMap);
  key = _.keys(charMap);
  regexp = new RegExp('[' + escapeRegExp(val.join('')) + ']', 'g');
  len = val.length;
  while (len--) {
    src = val.pop();
    dest = key.pop();
    for (i = 0, len1 = src.length; i < len1; i++) {
      char = src[i];
      replacements[char] = dest;
    }
  }
  return regexp;
};

module.exports = normalizeQuery = function(s) {
  if (typeof s !== 'string') {
    return '';
  }
  s = s.trim().replace(regexp || initRegExp(), function(c) {
    return replacements[c];
  });
  return s.toLowerCase();
};

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL1VzZXJzL2pwdmVyZGVqby9Hcm91cG9uL3Nscy9zcmMvZnJvbnRlbmQvaGVscGVyL3NlYXJjaC9oZWxwZXIvbV9ub3JtYWxpemVRdWVyeS5jb2ZmZWUiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIvVXNlcnMvanB2ZXJkZWpvL0dyb3Vwb24vc2xzL3NyYy9mcm9udGVuZC9oZWxwZXIvc2VhcmNoL2hlbHBlci9tX25vcm1hbGl6ZVF1ZXJ5LmNvZmZlZSJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxJQUFBOztBQUFDLGVBQWdCLE9BQUEsQ0FBUSx1REFBUjs7QUFDakIsTUFBQSxHQUFTLFlBQUEsR0FBZTs7QUFFeEIsVUFBQSxHQUFhLFNBQUE7QUFFWCxNQUFBO0VBQUEsT0FBQSxHQUFVLE1BQU0sQ0FBQyxPQUFPLENBQUMsRUFBRSxDQUFDLElBQUksQ0FBQyxXQUF2QixJQUFzQztFQUVoRCxZQUFBLEdBQWU7RUFDZixNQUFBLEdBQVM7RUFFVCxHQUFBLEdBQU0sQ0FBQyxDQUFDLE1BQUYsQ0FBUyxPQUFUO0VBQ04sR0FBQSxHQUFNLENBQUMsQ0FBQyxJQUFGLENBQU8sT0FBUDtFQUNOLE1BQUEsR0FBYyxJQUFBLE1BQUEsQ0FBTyxHQUFBLEdBQU0sWUFBQSxDQUFhLEdBQUcsQ0FBQyxJQUFKLENBQVMsRUFBVCxDQUFiLENBQU4sR0FBbUMsR0FBMUMsRUFBK0MsR0FBL0M7RUFDZCxHQUFBLEdBQU0sR0FBRyxDQUFDO0FBQ1YsU0FBTSxHQUFBLEVBQU47SUFDRSxHQUFBLEdBQU0sR0FBRyxDQUFDLEdBQUosQ0FBQTtJQUNOLElBQUEsR0FBTyxHQUFHLENBQUMsR0FBSixDQUFBO0FBQ1AsU0FBQSx1Q0FBQTs7TUFBQSxZQUFhLENBQUEsSUFBQSxDQUFiLEdBQXFCO0FBQXJCO0VBSEY7U0FLQTtBQWhCVzs7QUFrQmIsTUFBTSxDQUFDLE9BQVAsR0FBaUIsY0FBQSxHQUFpQixTQUFDLENBQUQ7RUFDaEMsSUFBaUIsT0FBTyxDQUFQLEtBQVksUUFBN0I7QUFBQSxXQUFPLEdBQVA7O0VBQ0EsQ0FBQSxHQUFJLENBQUMsQ0FBQyxJQUFGLENBQUEsQ0FBUSxDQUFDLE9BQVQsQ0FBa0IsTUFBQSxJQUFVLFVBQUEsQ0FBQSxDQUE1QixFQUEyQyxTQUFDLENBQUQ7V0FDN0MsWUFBYSxDQUFBLENBQUE7RUFEZ0MsQ0FBM0M7U0FFSixDQUFDLENBQUMsV0FBRixDQUFBO0FBSmdDIn0=
